export const reasoningOf = (input) => {
    if (input == null || typeof input !== 'object' || !('reasoning' in input)) {
        return null;
    }
    const reasoning = input.reasoning;
    return typeof reasoning === 'string' && reasoning.length > 0
        ? reasoning
        : null;
};
//# sourceMappingURL=reasoning.js.map